import React, { memo } from 'react';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useStyles from 'hooks/useStyles';
import { View } from 'react-native';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { rem } from './values';
import { isWeb } from '../constants';
const BottomPanel = ({ style, isInTab, children, }) => {
    // Every web screen sits beside the sidebar, so it uses the tab column there
    const { paddingHorizontal } = useAppFrameDimensions(isWeb || isInTab);
    const { paddingBottom } = useMarginBottom('paddingBottom');
    const styles = useStyles(styleSet);
    return (<View style={[
            styles.container,
            { paddingBottom: isInTab ? rem(16) : paddingBottom },
            {
                paddingHorizontal: paddingHorizontal + rem(16),
            },
            style,
        ]}>
      {children}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingTop: rem(16),
        borderTopColor: colors.borders.divider,
        backgroundColor: colors.cards.onDark,
        borderTopWidth: rem(1),
    },
}));
export default memo(BottomPanel);
